import React from 'react';

const MyOrder = () => {
    return (
        <div>
            <h1 className="text-center text-info p-d my-5">Thanks For Booking This Service.</h1>
        </div>
    );
};

export default MyOrder;